<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="true" :show-search-form="false"  @btnHandler="btnHandler"
                @fetchData="fetchData">
      <template slot="status" slot-scope="{ row }">
        <Tag checkable color="primary" v-if="row.status === 0">已下单未支付</Tag>
        <Tag checkable color="success" v-if="row.status === 1">已支付</Tag>
        <Tag checkable color="warning" v-if="row.status === 2">取消支付</Tag>
        <Tag checkable color="error" v-if="row.status === 3">支付失败</Tag>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Tooltip content="编辑" placement="top" transfer>
          <Button type="info" size="small" icon="md-create" style="margin-right: 5px" @click="btnHandler('edit', row)"/>
        </Tooltip>
      </template>
    </page-table>

    <Modal width="500" :title="formData.title" v-model="formData.visible" @on-ok="onSubmit">
      <Form label-width="100">
        <FormItem v-for="item in formData.fields" :key="item.key" :label="item.label">
          <Input v-if="item.type === 'input'" v-model="formData.data[item.key]"/>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import OrderDetail from './components/order-dateil'
import { getLevelList, saveLevel } from '@/api/member'

export default {
  name: 'level',
  components: { OrderDetail, pageTable },
  data () {
    return {
      params: {
        keywords: '',
        paid_at: []
      },
      tableLoading: false,
      tableData: [],
      pageTotal: 0,
      formData: {
        visible: false,
        title: '',
        fields: [
          { label: '名称', key: 'name', type: 'input' },
          { label: '价格', key: 'price', type: 'input' }
        ],
        data: {}
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { title: 'ID', key: 'id', width: 160 },
        { title: '会员名称', key: 'name' },
        { title: '价格', key: 'price' },
        { title: '操作', slot: 'action', width: 80, align: 'center', fixed: 'right' }
      ]
    }
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getLevelList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    new () {
      this.formData.visible = true
      this.formData.title = '新增'
      this.formData.data = {}
    },
    edit (row) {
      this.formData.visible = true
      this.formData.title = '编辑'
      this.formData.data = { ...row }
    },
    onSubmit () {
      saveLevel({ ...this.formData.data }).then(() => {
        this.$Message.success({
          content: '保存成功~'
        })
        this.fetchData()
      }).finally(() => {
      })
    }
  }
}
</script>

<style scoped>

</style>
